import colours from "./colours";
import transitions from './transitions';
import { fonts } from "./fonts";

const mixins = {
    bloop: `
        transition: transform ${transitions.transitionFastest};
        &:hover {
            transform: scale(1.1);
        }
    `,
    bloopScale: `
        transform: scale(1.1);
    `,
    placeholderAttributes: (content?: any) => `
        font-family: ${fonts.frutiger};
        font-weight: ${fonts.weights.light};
        color: ${colours.grey[450]};
        opacity: 1; /** Safari / Firefox **/

        ${content};
    `,

    placeholder: (content?: any) => `
        &::placeholder { /** Chrome **/
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** This css doesn't work with the list below **/
        &::-webkit-input-placeholder, /** Opera/Safari **/
        &::-moz-placeholder, /** Firefox 19+ **/
        &:-moz-placeholder { /** Firefox 18- **/
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** IE: This css doesn't work with the list above **/
        &:-ms-input-placeholder {
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }

        /** Edge: This css doesn't work with the list above **/
        &::-ms-input-placeholder {
            ${mixins.placeholderAttributes(content)};

            /** We put @content after the above include, so that the @content can override **/
            ${content};
        }
    `,
    input: (backgroundColor?: string) => `
        input,
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            background-color: ${backgroundColor};
            -webkit-box-shadow: 0 0 0 30px ${backgroundColor} inset;
        }
    `,
    dangerouslySetInnerHtml: `
        strong {
            font-weight: bold;
        }

        em {
            font-style: italic;
        }

        blockquote {
            margin-left: 40px;
        }

        table {
            width: 100%;
        }

        td {
            border: 1px solid ${colours.silverChalice2};
            vertical-align: middle;
        }

        ul,ol {
            margin-left: 40px;
        }

        ul {
            list-style: disc;
        }

        ol {
            list-style: decimal;
        }
    `,
    button: {
        reset: `
            margin: 0;
            border: 0;
            padding: 0;
            color: inherit; // E.g. to inherit the root's #040404 default text colour.
            font-family: inherit;
            font-size: inherit;
            font-weight: inherit;
            background: none;
    
            :focus {
                outline: none;
            }
        `
    },
    visuallyHidden: `
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
    `,
};

const v = {
    ...mixins,
};

export default v;
